import { AdvanceSummary, ItemHistoryRecord } from '@skylab-shared/dataModel';
import { unique } from '@skylab-shared/utils';

export const vatRateChangedOnSaleAdvance = (summary: AdvanceSummary) => (
    Object.values(summary.itemsHistory)
        .map(historyRecord => historyRecord.map(item => item.vatRate))
        .map(vatRates => unique(vatRates))
        .some(historyRecord => historyRecord.length > 1)
);

export const vatRateChangedOnSaleAdvanceItem = (itemHistoryRecords: ItemHistoryRecord[]) => (
    unique(itemHistoryRecords.map(item => item.vatRate)).length > 1
);
